export default function createPreconditionMethods(params) {
  // 外链创建先决条件,过滤接口
  const newCreatePreconditionParams = {
    IS_APPROVE_POLICY_UPLOAD: params.is_approve_policy_upload,
    SIZE: params.size || '',
  }
  const MODE = params.mode
  if (MODE.indexOf('r') > -1) {
    newCreatePreconditionParams.DOWNLOAD = true
  } else {
    newCreatePreconditionParams.DOWNLOAD = false
  }
  if (MODE.indexOf('w') > -1) {
    newCreatePreconditionParams.UPLOAD = true
  } else {
    newCreatePreconditionParams.UPLOAD = false
  }
  if (MODE.indexOf('p') > -1) {
    newCreatePreconditionParams.PREVIEW = true
  } else {
    newCreatePreconditionParams.PREVIEW = false
  }
  if (params.ctime) {
    newCreatePreconditionParams.IS_CHANGE_EOD = true
  } else {
    newCreatePreconditionParams.IS_CHANGE_EOD = false
  }
  if (params.is_approval) {
    newCreatePreconditionParams.IS_APPROVAL = true
  } else {
    newCreatePreconditionParams.IS_APPROVAL = false
  }
  if (params.is_snapshot) {
    newCreatePreconditionParams.IS_SNAPSHOT = true
  } else {
    newCreatePreconditionParams.IS_SNAPSHOT = false
  }
  if (params.is_login_verify) {
    newCreatePreconditionParams.IS_LOGIN_VERIFY = true
  } else {
    newCreatePreconditionParams.IS_LOGIN_VERIFY = false
  }
  if (params.is_protected) {
    newCreatePreconditionParams.IS_PROTECTED = true
  } else {
    newCreatePreconditionParams.IS_PROTECTED = false
  }
  if (params.max_expiration > -1) {
    newCreatePreconditionParams.MAX_EXPIRATION = true
    newCreatePreconditionParams.MAX_EXPIRATION_VALUE = params.max_expiration
  } else {
    newCreatePreconditionParams.MAX_EXPIRATION = false
  }
  if (params.type === 'file') {
    newCreatePreconditionParams.UPLOAD_SHOW = false
    newCreatePreconditionParams.MAX_DOWNLOAD_COUNT_SHOW = true
  } else {
    newCreatePreconditionParams.UPLOAD_SHOW = true
    newCreatePreconditionParams.MAX_DOWNLOAD_COUNT_SHOW = false
  }
  if (params.type === 'file' && params.max_download_count > -1) {
    newCreatePreconditionParams.MAX_DOWNLOAD_COUNT = true
    newCreatePreconditionParams.MAX_DOWNLOAD_COUNT_VALUE = params.max_download_count
  } else {
    newCreatePreconditionParams.MAX_DOWNLOAD_COUNT = false
  }
  if (params.eod_id > -1) {
    newCreatePreconditionParams.EOD_CONTROL = true
    newCreatePreconditionParams.EOD_ID = true
    newCreatePreconditionParams.EOD_ID_VALUE = params.eod.id
  } else {
    newCreatePreconditionParams.EOD_CONTROL = false
    newCreatePreconditionParams.EOD_ID = false
    newCreatePreconditionParams.EOD_ID_VALUE = ''
  }
  if (params.id) {
    newCreatePreconditionParams.DP_ID = true
    newCreatePreconditionParams.DP_ID_VALUE = params.id
  } else {
    newCreatePreconditionParams.DP_ID = false
  }
  if (params.eod_id > -1 && params.eod.eod_password !== null) {
    newCreatePreconditionParams.EOD_PASSWORD = true
  } else {
    newCreatePreconditionParams.EOD_PASSWORD = false
  }
  if (params.eod_id > -1 && params.eod.max_expiration > -1) {
    newCreatePreconditionParams.EOD_MAX_EXPIRATION = true
    newCreatePreconditionParams.EOD_MAX_EXPIRATION_VALUE = params.eod.max_expiration
  } else {
    newCreatePreconditionParams.EOD_MAX_EXPIRATION = false
  }
  if (params.eod_id > -1 && params.eod.max_read_times > -1) {
    newCreatePreconditionParams.MAX_READ_TIMES = true
    newCreatePreconditionParams.MAX_READ_TIMES_VALUE = params.eod.max_read_times
  } else {
    newCreatePreconditionParams.MAX_READ_TIMES = false
  }
  if (params.eod_id > -1 && params.eod.max_read_duration > -1) {
    newCreatePreconditionParams.MAX_READ_DURATION = true
    newCreatePreconditionParams.MAX_READ_DURATION_VALUE = params.eod.max_read_duration
  } else {
    newCreatePreconditionParams.MAX_READ_DURATION = false
  }
  if (params.eod_id > -1 && params.eod.is_print) {
    newCreatePreconditionParams.IS_PRINT = true
  } else {
    newCreatePreconditionParams.IS_PRINT = false
  }
  if (params.eod_id > -1 && params.eod.is_read_only) {
    newCreatePreconditionParams.IS_READ_ONLY = true
  } else {
    newCreatePreconditionParams.IS_READ_ONLY = false
  }
  if (params.eod_id > -1 && params.eod.is_expired_delete) {
    newCreatePreconditionParams.IS_EXPIRED_DELETE = true
  } else {
    newCreatePreconditionParams.IS_EXPIRED_DELETE = false
  }
  if (params.eod_id > -1 && params.eod.watermark_content !== null) {
    // 如果开启本地管控选项,并且添加水印强制管控的话,强制打勾并且传送水印内容
    newCreatePreconditionParams.LIMIT_WATERMARK_CONTENT = true
    newCreatePreconditionParams.LIMIT_WATERMARK_CONTENT_VALUE = params.eod.watermark_content
  } else if (params.eod_id === -1 && params.is_checked_watermark) {
    // 如果没有开启本地管控选项,但是添加水印强制管控的话,只强制打勾,水印内容随服务器走
    newCreatePreconditionParams.LIMIT_WATERMARK_CONTENT = true
  } else {
    newCreatePreconditionParams.LIMIT_WATERMARK_CONTENT = false
  }
  return newCreatePreconditionParams
}
